import { JsonApiPayload, ModelLike } from './JsonApiPayload';
import { ParkPayload } from 'services/payloads/ParkPayload';
import { RatePayload } from './RatePayload';

export class DiscountPayload extends JsonApiPayload {
  id: string
  pmsId: string
  parkId: string
  rateIds: string
  type: DiscountType
  name: string
  code: string
  loyaltyNumberLabel: string
  description: string
  usePercentage: boolean
  percentage: number
  amount: number
  amountCents: null
  amountCurrency: string
  availableOnlie: boolean
  active: boolean
  createdAt: string
  updatedAt: string
  // relationships
  park: ParkPayload
  rates: RatePayload

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    return super._getSchema(this, ['park', 'rates']);
  }
};

type DiscountType =  'regular' | 'code' | 'loyalty';
